<template>
	<div class="time-picker-options">
		<div class="time-picker-options__hours">
			<span class="time-picker-options__text">HH</span>
			<DropdownList
				ref="hoursListRef"
				:id="`hours${uid}_ddl`"
				:isOpen="true"
				:multiSelect="multiSelect"
				:options="hoursOpts"
				:value="dataValue.hours"
				@change="updateHoursValue"
			/>
		</div>

		<div class="time-picker-options__minutes">
			<span class="time-picker-options__text">MM</span>
			<DropdownList
				ref="minutesListRef"
				:id="`minutes${uid}_ddl`"
				:isOpen="true"
				:multiSelect="multiSelect"
				:options="minutesOpts"
				:value="dataValue.minutes"
				@change="updateMinutesValue"
			/>
		</div>

		<div class="time-picker-options__system">
			<div class="time-picker-options__system-btn">AM</div>
			<div class="time-picker-options__system-btn">PM</div>
		</div>

		<!-- <SegmentedControl
			name="AMPM"
			v-model="dataValue.cyclePeriod"
			:options="cyclePeriodOptions"
		>
		</SegmentedControl> -->

		<div class="time-picker-options__actions">
			<ButtonGroup>
				<template slot="container">
					<Button
						className="btn--primary"
						labelText="Done"
						:btnClick="doneAction"
					/>
					<Button
						className="btn--link"
						labelText="Clear"
						:btnClick="clearAction"
					/>
				</template>
			</ButtonGroup>
		</div>
	</div>
</template>
<script>
import Button from '@/components/forms/button/button';
import ButtonGroup from '@/components/forms/button/button-group';
/* import SegmentedControl from '@/components/forms/segmented-control/segmented-control.vue'; */
import dropdownMixins from '@/mixins/dropdown';
import { deepEqual as objCompare } from '@/utils/object';
import { TIME_FULL } from './time-picker-types';

export default {
	name: 'TimePickerOptions',
	components: {
		Button,
		ButtonGroup /* ,
		SegmentedControl */
	},
	mixins: [dropdownMixins],
	props: {
		value: {
			required: true
		},
		type: {
			type: String,
			default: null
		}
	},
	created() {
		this.generateDataOpts();
	},

	data() {
		return {
			hoursOpts: undefined,
			minutesOpts: undefined,
			secondsOpts: undefined,
			dataValue: undefined

			/* cyclePeriodOptions: [
				{ value: 'am', text: 'AM' },
				{ value: 'pm', text: 'PM' }
			] */
		};
	},
	methods: {
		generateDataOpts() {
			this.hoursOpts = this.generateDropdownOpts(12);
			this.minutesOpts = this.generateDropdownOpts();
			if (TIME_FULL) {
				//TODO: this opts is for the full time
				this.secondsOpts = this.generateDropdownOpts();
			}
		},
		generateDropdownOpts(n = 60) {
			return Array(n)
				.fill()
				.map((v, i) => ({
					text: `${i < 10 ? '0' : ''}${i}`,
					value: `${i < 10 ? '0' : ''}${i}`
				}));
		},
		emitValue() {
			this.$emit('input', this.dataValue);
			this.$emit('change', this.dataValue);
		},
		updateHoursValue(val) {
			this.dataValue.hours = val;
		},
		updateMinutesValue(val) {
			this.dataValue.minutes = val;
		},
		clearAction() {
			this.dataValue = {
				hours: '-1',
				minutes: '00',
				cyclePeriod: 'am'
			};
			this.emitValue();
		},
		doneAction() {
			this.$emit('close', true);
		}
	},
	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(val) {
				if (!objCompare(this.dataValue, val)) {
					this.dataValue = val;
				}
			}
		},
		dataValue: {
			deep: true,
			handler() {
				this.emitValue();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@/scss/5-objects/_form.scss';
.time-picker-options {
	width: 188px;
	display: grid;
	grid-template-columns: 1fr 1fr auto;
	column-gap: $gutter-md;
	row-gap: $gutter-lg;
	padding: $padding-md;
	@include stylized-dropdown;

	&__hours,
	&__minutes,
	&__system {
		display: flex;
		flex-direction: column;
	}

	&__text {
		width: calc(100% - 12px);
		font-size: 13px;
		text-align: center;
		margin-bottom: $gutter-sm;
	}

	&__system {
		padding-top: 19px;
		gap: $gutter-sm;
	}

	&__system-btn {
		cursor: pointer;
		width: 32px;
		height: 32px;
		@include vertical-horizontal-center-with-flex;
		border-radius: $btn-border-radius;
		font-size: $btn-font-size;

		&:hover {
			background: $btn-primary-bkgd-hover;
			color: $white;
		}

		&.is-selected {
			background: $btn-primary-bkgd;
			color: $white;
		}
	}

	&__actions {
		grid-column: 1 / 4;
		display: flex;
		justify-content: space-around;
	}
}

::v-deep .dropdown__list-container {
	border: 0;
	border-radius: 0;
}

::v-deep .dropdown-list {
	padding: 0;
	margin-block-start: 0px;
	max-height: 144px;
	@include scrollbar('small');
}

::v-deep .list-item {
	justify-content: center;
}
</style>
